var _circle, _path, _circle2, _path2, _circle3, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReffsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 5,
  r: 2.2,
  fill: "#1ACDFF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1ACDFF",
  d: "M9 8.2h6v3.2c0 .5-.4.9-.9.9H9.9c-.5 0-.9-.4-.9-.9z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 15,
  r: 2.2,
  fill: "#1ACDFF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#007B9D",
  d: "M4.2 18h4.6v2.8c0 .5-.4.9-.9.9H5.1c-.5 0-.9-.4-.9-.9z"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 15,
  r: 2.2,
  fill: "#1ACDFF"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#007B9D",
  d: "M15.2 18h4.6v2.8c0 .5-.4.9-.9.9h-2.8c-.5 0-.9-.4-.9-.9z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1ACDFF",
  strokeLinecap: "round",
  strokeWidth: 1.2,
  d: "M9.5 10.5Q4 12 5.5 16M14.5 10.5q5.5 1.5 4 5.5M7 19.5q5 2 10 0"
})));
export default SvgReffsIcon;